import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export function Carousel() {
    new Swiper(".carousel", {
        loop: true,
        effect: 'fade',
        speed: 500,
        slidesPerView: 1,
        allowTouchMove: false,
        autoplay: {
            delay: 3000
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        lazy: {
            loadPrevNext: true, // Load images in adjacent slides
        }
    });
}
